import {hasFeatureFlag} from '@/forecast-app/shared/util/FeatureUtil';
import {partition} from 'lodash';

const actualsColumnNames = ['actual-price', 'billable-time-entries', 'non-billable-time-entries'];
const hoursPointsColumnNames = [
	'billable-time-entries',
	'non-billable-time-entries',
	'over-forecast',
	'forecast',
	'remaining',
	'time-entries',
];

type AvailableColumn = {
	name: string;
	disabled: boolean;
	checked: boolean;
	translationId: string;
	nestedOptions?: AvailableColumn[];
};
export const groupEyeOptions = (availableColumns: AvailableColumn[]): AvailableColumn[] => {
	if (hasFeatureFlag('financial_categories_update')) {
		const [hoursPointsOptions, restColumns] = partition(availableColumns, column => {
			return hoursPointsColumnNames.includes(column.name);
		});
		const hoursPointsOption = {
			name: 'hours-points',
			disabled: false,
			checked: hoursPointsOptions.some(option => option.checked),
			translationId: 'common.hours_and_points',
			nestedOptions: hoursPointsOptions,
		};
		return [hoursPointsOption, ...restColumns];
	}
	const [actualsOptions, restColumns] = partition(availableColumns, column => {
		return actualsColumnNames.includes(column.name);
	});

	const actualsOption = {
		name: 'actuals',
		disabled: false,
		checked: actualsOptions.some(option => option.checked),
		translationId: 'project_budget.actuals',
		nestedOptions: actualsOptions,
	};

	return actualsOptions && actualsOptions.length > 0 ? [actualsOption, ...restColumns] : restColumns;
};

const getColumnNameWithEyeOptionPrefix = (column: AvailableColumn): string => {
	const hasFinancialCategories = hasFeatureFlag('financial_categories_update');
	if (!hasFinancialCategories && actualsColumnNames.includes(column.name)) {
		return `actuals.${column.name}`;
	}
	if (hasFinancialCategories && hoursPointsColumnNames.includes(column.name)) {
		return `hours-points.${column.name}`;
	}

	return column.name;
};

type EyeOption = {
	[key: string]: boolean;
};
export const eyeOptionsToCols = (eyeOptions: EyeOption, availableColumns: AvailableColumn[]): AvailableColumn[] => {
	return availableColumns.map(column => {
		const path = getColumnNameWithEyeOptionPrefix(column);
		const checkedFromEye = eyeOptions[path];
		return {
			...column,
			checked: checkedFromEye !== undefined ? checkedFromEye : column.checked,
		};
	});
};
